import { useTranslation } from 'react-i18next';

import { PRIMARY, DARK } from 'constants/colors';
import { MULTIDRAG_OVERLAY_WIDTH } from 'constants/widths';

import { Box } from '@mui/material';

import { BaseChip } from '../TimelineView/AppointmentChip/Chip.styles';

// "X selected" pill for Pragmatic multi-drag; positioning handled natively by
// setCustomNativeDragPreview + centerUnderPointer, so no transform math.
const MultiDragPreviewPragmatic = ({ count }: { count: number }) => {
  'use memo';
  const { t } = useTranslation('common');

  return (
    <Box>
      <BaseChip
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          background: DARK,
          width: `${MULTIDRAG_OVERLAY_WIDTH}px`,
          boxSizing: 'border-box',
          fontSize: '11px',
          padding: '2px',
          color: 'white'
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            background: PRIMARY
          }}
        >
          {count}
        </Box>
        {t('activityPlanning.selected')}
      </BaseChip>
    </Box>
  );
};

export default MultiDragPreviewPragmatic;
